export default "__VITE_ASSET__007ffff5__"